import { render } from "./featuresItemBg.vue?vue&type=template&id=6d1cfcb4"
import script from "./featuresItemBg.vue?vue&type=script&lang=js"
export * from "./featuresItemBg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__